<template>
<div>
    
    <m-daily-schedule-intervals
        label="Monday"
        v-model="schedule.monday_intervals"
        :read_only="read_only"
        v-on:copy_weekday="copyWeekday"
        v-on:input="onChange"
        v-on:copy_all="copyAll"
        first
    />

    <m-daily-schedule-intervals
        label="Tuesday"
        v-model="schedule.tuesday_intervals"
        :read_only="read_only"
        v-on:copy_weekday="copyWeekday"
        v-on:input="onChange"
        v-on:copy_all="copyAll"
    />

    <m-daily-schedule-intervals
        label="Wednesday"
        v-model="schedule.wednesday_intervals"
        :read_only="read_only"
        v-on:copy_weekday="copyWeekday"
        v-on:input="onChange"
        v-on:copy_all="copyAll"
    />

    <m-daily-schedule-intervals
        label="Thursday"
        v-model="schedule.thursday_intervals"
        :read_only="read_only"
        v-on:copy_weekday="copyWeekday"
        v-on:input="onChange"
        v-on:copy_all="copyAll"
    />

    <m-daily-schedule-intervals
        label="Friday"
        v-model="schedule.friday_intervals"
        :read_only="read_only"
        v-on:copy_weekday="copyWeekday"
        v-on:input="onChange"
        v-on:copy_all="copyAll"
    />

    <m-daily-schedule-intervals
        label="Saturday"
        v-model="schedule.saturday_intervals"
        :read_only="read_only"
        v-on:copy_weekend="copyWeekend"
        v-on:input="onChange"
        v-on:copy_all="copyAll"
    />

    <m-daily-schedule-intervals
        label="Sunday"
        v-model="schedule.sunday_intervals"
        :read_only="read_only"
        v-on:copy_weekend="copyWeekend"
        v-on:input="onChange"
        v-on:copy_all="copyAll"
    />

    <m-daily-schedule-intervals
        v-for="(item, index) in schedule.custom_intervals"
        :key="index"
        :label="toUSDate(item.date)"
        :date="item.date"
        v-model="item.intervals"
        :read_only="read_only"
        v-on:input="onChange"
        v-on:delete="onDelete(index)"
        v-on:change-date="onChangeDate(index,$event)"
    />

    <div class="add_container"
        v-if="!read_only"
    >
        <v-btn
            dense
            v-on:click="onClickAddCustomDate"
        >
            Add Custom schedule for date...
        </v-btn>
    </div>

    <m-date-picker-dialog
        v-if="!read_only"
        ref="choose-date-dialog"
        title="Select Date"
        v-on:ok="onAddCustomDate"
    />

</div>
</template>

<script>
const _ = require('lodash');

let default_schedule =  {
                "monday_intervals" : [ "9:00 AM - 5:00 PM" ],
                "tuesday_intervals" : [ "9:00 AM - 5:00 PM" ],
                "wednesday_intervals" : [ "9:00 AM - 5:00 PM" ],
                "thursday_intervals" : [ "9:00 AM - 5:00 PM" ],
                "friday_intervals" : [ "9:00 AM - 5:00 PM" ],
                "saturday_intervals" : [ "9:00 AM - 5:00 PM" ],
                "sunday_intervals" : [ "9:00 AM - 5:00 PM" ],
                "custom_intervals" : [ ]
            };

export default {
    props: {
        value: {
            type: Object,
            default: function() { return {}; }
        },

        read_only: {
            type: Boolean,
            default: function() { return true; }
        },
    },

    data() {
        return {
            schedule: _.cloneDeep(default_schedule),
        }
    },

    mounted () {
        this.setSchedule(this.value);
    },

    methods: {
        setSchedule(val)
        {
            this.schedule = _.cloneDeep(val);
        },

        toUSDate(date) 
        {
            let arr = date.split('-');

            return arr[1]+'/'+arr[2]+'/'+arr[0];
        },

        copyWeekday(value)
        {
            this.schedule.monday_intervals = value;
            this.schedule.tuesday_intervals = value;
            this.schedule.wednesday_intervals = value;
            this.schedule.thursday_intervals = value;
            this.schedule.friday_intervals = value;

            this.onChange();
        },

        copyWeekend(value)
        {
            this.schedule.saturday_intervals = value;
            this.schedule.sunday_intervals = value;

            this.onChange();
        },

        copyAll(value)
        {
            this.schedule.monday_intervals = value;
            this.schedule.tuesday_intervals = value;
            this.schedule.wednesday_intervals = value;
            this.schedule.thursday_intervals = value;
            this.schedule.friday_intervals = value;
            this.schedule.saturday_intervals = value;
            this.schedule.sunday_intervals = value;

            this.onChange();
        },

        onDelete(index)
        {
            this.schedule.custom_intervals.splice(index,1);
            this.onChange();
        },

        onChange()
        {
            this.$emit('input',this.schedule);
        },

        onClickAddCustomDate()
        {
            this.$refs['choose-date-dialog'].showDialog();
        },

        onAddCustomDate(date)
        {
            let new_date = {
                'date' : date,
                'intervals': [],
            };

            this.schedule.custom_intervals.push(new_date);

            this.onChange();
        },

        onChangeDate(index, new_date)
        {
            this.schedule.custom_intervals[index].date = new_date;
            this.onChange();
        }
    },

    watch: {
        value(newValue, oldValue) {
            this.setSchedule(newValue);
        }
    },
}
</script>

<style lang="scss" scoped>

.add_container {
    border-top: 1px solid rgb(232,232,232);
    text-align: center;
    padding-top: 15px;
    padding-bottom: 15px;
}

</style>